import React, { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Avatar, Box, Divider, Drawer, Hidden, List, Typography, makeStyles } from "@material-ui/core";
import * as FeatherIcons from "react-feather";
import NavItem from "./NavItem";
import store from "../../../redux/store";

const avatar= "/static/images/avatars/avatar_7.png"

const items = [
  {
    href: "/app/dashboard",
    icon: FeatherIcons.BarChart,
    title: "Dashboard",
    role: ["Admin","Accountant","Guest","Worker"],
    param:null
  },
  {
    href: "/app/worker_profile",
    icon: FeatherIcons.Settings,
    title: "Profile",
    role: ["Worker"],
    param:"/{id}"
  }, 
  {
    href: "/app/worker_demander_profile",
    icon: FeatherIcons.Settings,
    title: "Profile",
    role: ["Client"],
    param:"/{id}"
  }, 
  {
    href: "/app/work_requests",
    icon: FeatherIcons.GitPullRequest,
    title: "Work Requests",
    role: ["Client"],
    param:"/{id}"
  },     
  {
    href: "/app/worker_registration",
    icon: FeatherIcons.Book,
    title: "Worker Registration Form",
    role: ["Admin","Accountant","Guest"],  
    param:null 
  },
  {
    href: "/app/work_request",
    icon: FeatherIcons.Book,
    title: "Request a Work Form",
    role: ["Admin","Accountant","Guest","Client"], 
    param:null

  },
  {
    href: "/app/work_list",
    icon: FeatherIcons.Briefcase,
    title: "Work List",
    role: ["Admin","Accountant","Client"],
    param:null
  },
  {
    href: "/app/work_hour",
    icon: FeatherIcons.Briefcase,
    title: "Work Hour Entry",
    role: ["Admin","Accountant","Client","Worker"],
    param:null
  },
  {
    href: "/app/agenda",
    icon: FeatherIcons.Calendar,
    title: "Agenda",
    role: ["Admin","Accountant"],
    param:null
  },  
  {
    href: "/app/worker_demander_management",
    icon: FeatherIcons.Command,
    title: "Client Management",
    role: ["Admin","Accountant"],
    param:null
  },
  {
    href: "/app/asset_management",
    icon: FeatherIcons.Command,
    title: "Asset Management",
    role: ["Admin","Accountant"],
    param:null
  },
  {
    href: "/app/worker_management",
    icon: FeatherIcons.Command,
    title: "Worker Management",
    role: ["Admin","Accountant"],
    param:null
  },
  {
    href: "/app/dashboard",
    icon: FeatherIcons.Command,
    title: "_Foreign Firm Management",
    role: ["Admin","Accountant"],
    param:null
  },
  {
    href: '/logout',
    icon: FeatherIcons.Lock,
    title: 'Logout',
    role: ["Admin","Accountant","Guest","Client","Worker"], 
    param:null
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const state = store.getState();
  const {userName, role ,party_id } = state.authReducer;

  const classes = useStyles();
  const location = useLocation();

  function denenemenu(item) {
    var exists = item.role.some((o) => o === role);
    if (exists) {
      let href =item.href
      if (item.param) {
        const id = party_id ===0?"26":party_id;
        href = href+ "/"+ id;
      }
      return (
        <NavItem
          href={href}
          key={item.title}
          title={item.title}
          icon={item.icon}
        />
      );
    } 
    else {
      return null;
    }
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={avatar}
          to="/app/account"
        />
        <Typography className={classes.name} color="textPrimary" variant="h5">
          {userName}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {role}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>{items.map((item) => denenemenu(item))}</List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default NavBar;
